
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CustomCategoryRequest,
  FamiliesAndCategoriesRequest,
} from '../models';
import {
    CustomCategoryRequestFromJSON,
    CustomCategoryRequestToJSON,
    FamiliesAndCategoriesRequestFromJSON,
    FamiliesAndCategoriesRequestToJSON,
} from '../models';

export interface UpdateFamiliesAndCategoriesRequest {
    familiesAndCategoriesRequest: FamiliesAndCategoriesRequest;
}

export interface UpdateFamiliesAndCategoriesWithCustomCategoryRequest {
    customCategoryRequest: CustomCategoryRequest;
}

/**
 * 
 */
export class FamiliesAndCategoriesApi extends runtime.BaseAPI {

    /**
     * Update families and categories info for a given profile
          */
    async updateFamiliesAndCategoriesRaw(requestParameters: UpdateFamiliesAndCategoriesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['familiesAndCategoriesRequest'] == null) {
            throw new runtime.RequiredError(
                'familiesAndCategoriesRequest',
                'Required parameter "familiesAndCategoriesRequest" was null or undefined when calling updateFamiliesAndCategories().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/profile/api/families-and-categories`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FamiliesAndCategoriesRequestToJSON(requestParameters['familiesAndCategoriesRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update families and categories info for a given profile
          */
    async updateFamiliesAndCategories(requestParameters: UpdateFamiliesAndCategoriesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateFamiliesAndCategoriesRaw(requestParameters, initOverrides);
    }

    /**
     * Update families and categories info with a custom category for a given profile
          */
    async updateFamiliesAndCategoriesWithCustomCategoryRaw(requestParameters: UpdateFamiliesAndCategoriesWithCustomCategoryRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['customCategoryRequest'] == null) {
            throw new runtime.RequiredError(
                'customCategoryRequest',
                'Required parameter "customCategoryRequest" was null or undefined when calling updateFamiliesAndCategoriesWithCustomCategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/profile/api/families-and-categories/custom`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CustomCategoryRequestToJSON(requestParameters['customCategoryRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update families and categories info with a custom category for a given profile
          */
    async updateFamiliesAndCategoriesWithCustomCategory(requestParameters: UpdateFamiliesAndCategoriesWithCustomCategoryRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateFamiliesAndCategoriesWithCustomCategoryRaw(requestParameters, initOverrides);
    }

}
